import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {Row, Col, Nav, NavItem, PageHeader, Popover, Overlay} from 'react-bootstrap'
import {push} from '../../core/redux/router'
import {linkFinder} from '../../core/links'
import phonez from '../../core/phonez'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import ProviderScores from './ProviderScores'
import AddProviderContactPopover from './AddProviderContactPopover'
import DefineContactInfosForProviderCompanyPopover from './DefineContactInfosForProviderCompanyPopover'
import style from './ProviderDetail.less'

class ProviderDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedPopover: null})
    }

    render() {
        const {children, dispatch, location, authenticated, provider, _contactLinks} = this.props
        const {openedPopover} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {_contactLinks.find(linkFinder('AddProviderContact')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AddProviderContactPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.newProviderContact}</span>
                            </a>
                        </li>
                    )}
                    {provider._links.find(linkFinder('DefineContactInfosForProviderCompany')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'DefineContactInfosForProviderCompanyPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.defineContactInfo}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={() => this._closePopover()}>
                {popover}
            </Overlay>
        )

        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{provider.name}</span>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {_contactLinks.find(linkFinder('AddProviderContact')) && editOverlay('AddProviderContactPopover', (
                            <AddProviderContactPopover
                                provider={provider}
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {provider._links.find(linkFinder('DefineContactInfosForProviderCompany')) && editOverlay('DefineContactInfosForProviderCompanyPopover', (
                            <DefineContactInfosForProviderCompanyPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                    </PageHeader>
                    <Row>
                        <Col sm={4}>
                            <div className={style.contact}>
                                <h4>{i18n.contactInformation}</h4>
                                <ul>
                                    {provider.contactInfos && (
                                        <li>
                                            <label> {provider.contactInfos.name.firstName} {provider.contactInfos.name.lastName} {provider.contactInfos.name.value}</label>
                                        </li>
                                    )}
                                    {provider.contactInfos && provider.contactInfos.phones.length > 0 && (
                                        <li>
                                            <label>{i18n.phone} :</label>
                                            {provider.contactInfos.phones.map((phone, index) => (
                                                <span key={index}>
                                                    {index > 0 && (<span> |</span>)}
                                                    <span> {phonez(phone).format()}</span>
                                                </span>
                                            ))}
                                        </li>
                                    )}
                                    {provider.contactInfos && provider.contactInfos.emails.length > 0 && (
                                        <li>
                                            <label>{i18n.email} :</label>
                                            {provider.contactInfos.emails.map((email, index) => (
                                                <span key={index}>
                                                    {index > 0 && (<span> |</span>)}
                                                    <span> {email}</span>
                                                </span>
                                            ))}
                                        </li>
                                    )}
                                    {provider.contactInfos && provider.contactInfos.fax.length > 0 && (
                                        <li>
                                            <label>{i18n.fax} :</label>
                                            {provider.contactInfos.fax.map((fax, index) => (
                                                <span key={index}>
                                                    {index > 0 && (<span> |</span>)}
                                                    <span> {phonez(fax).format()}</span>
                                                </span>
                                            ))}
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <ProviderScores />
                        </Col>
                        <Col sm={4}>
                            <div className={style.event}>
                                <h4>
                                    {i18n.interventionCount}
                                </h4>
                                <div className={style.count}>
                                    <span>---</span>
                                    <Icon icon='file' size='xl' />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem
                            active={location.pathname.match(/^\/\w+\/[\w-]+$/) != null}
                            onClick={() => dispatch(push('/*/' + provider.uid))}>
                            {i18n.synthesis}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/^\/\w+\/[\w-]+\/providercontacts/) != null}
                            onClick={() => dispatch(push('/*/' + provider.uid + '/providercontacts'))}>
                            {i18n.providerContactsz}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/^\/\w+\/[\w-]+\/activities/) != null}
                            onClick={() => dispatch(push('/*/' + provider.uid + '/activities'))}>
                            {i18n.activities}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.tickets}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.documents}
                        </NavItem>
                    </Nav>
                </div>
                {children}
            </div>
        )
    }
}

ProviderDetail = connect((state) => ({
    location: state.router.location,
    authenticated: state.user.authenticated,
    provider: state.provider.provider,
    _contactLinks: state.provider.contact._links
}))(ProviderDetail)

export default ProviderDetail


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderDetail.js